import { Button, Flex, pxToRem, useTheme } from '@archipro-design/aria';
import { Tag } from '@archipro-design/icons';
import type { FC } from 'react';
import React from 'react';
import type { TagType } from '~/modules/product-tagging/type';
import TagPopoverBody from './TagPopoverBody';
import { PADDING_TOP_CAPTION_MOBILE } from '../../common/pagebuilder.style';
import BottomDrawer from '~/modules/detail/components/bottom-drawer/BottomDrawer';
import type { ColumnDimensionType } from '@modules/page-builder/types';

interface TagPopoverProps {
    tags: TagType[];
    dimension: ColumnDimensionType;
}

const TagPopover: FC<TagPopoverProps> = ({ tags, dimension }) => {
    const [modalOpen, setModalOpen] = React.useState(false);

    const theme = useTheme();

    const tagCount = tags.length;

    const toggleModal = (value: boolean) => setModalOpen(value);

    return (
        <>
            {modalOpen && (
                <BottomDrawer
                    open={modalOpen}
                    toggleModal={toggleModal}
                    title={'Products tagged in this photo'}
                >
                    <TagPopoverBody dimension={dimension} tags={tags} />
                </BottomDrawer>
            )}
            <Flex
                gap="space-8"
                vAlign="center"
                styles={{ marginTop: pxToRem(PADDING_TOP_CAPTION_MOBILE) }}
            >
                <Tag
                    color={theme.siteVariables.bodyColor}
                    styles={{ width: pxToRem(20), height: pxToRem(20) }}
                />
                <Button
                    transparent
                    size={14}
                    variables={{ buttonPadding: 0, iconPadding: 0 }}
                    onClick={() => setModalOpen(true)}
                    styles={{ color: theme.siteVariables.bodyColor }}
                >
                    Products tagged ({tagCount})
                </Button>
            </Flex>
        </>
    );
};

export default TagPopover;
